import PrinterIcon from '@/features/ui/icons/components/PrinterIcon'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const Header: FC = () => {
    const { t } = useTranslation()

    return (
        <View style={styles.header}>
            <PrinterIcon width="24" height="24" />
            <Typography.Heading variant="h2">
                {t('settings.printers.printerConfiguration.heading')}
            </Typography.Heading>
        </View>
    )
}

const styles = StyleSheet.create({
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
})

export default Header
